import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import transformRelationProduct from "core-web/utils/dataTransformers/transformRelationProduct";
import ProductSlider from "theme/components/contentBlocks/ProductSlider";
import BleedWrapper from "theme/components/wrappers/BleedWrapper";

const UPSELL_COMBINED = "upsell_combined";
const UPSELL_RELATED = "upsell_related";
const SKELETON_PRODUCTS_AMOUNT = 4;

const RelationSlider = ({ items, title, link, isLoading }) => {
    const products = isLoading ? [] : items.map(transformRelationProduct).filter(Boolean);

    if (!isLoading && !products.length) {
        return null;
    }

    return (
        <BleedWrapper mb={["40px", null, null, null, "60px"]}>
            <ProductSlider
                products={products}
                productsAmount={products.length || SKELETON_PRODUCTS_AMOUNT}
                headingText={title}
                headingTag="h2"
                url={link?.url}
                linkText={link?.text}
            />
        </BleedWrapper>
    );
};

RelationSlider.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.object),
    link: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
    }),
    title: PropTypes.string,
};

RelationSlider.defaultProps = {
    items: [],
    link: null,
    title: "",
};

const RelatedProductsSlider = ({ relationsByCode, relationsFetched }) => {
    const upsellOptions = useSelector(({ application }) => application.config?.options?.product_page?.upsell) || {};

    const isLoading = !relationsFetched;
    const combinedItems = relationsByCode?.[UPSELL_COMBINED] || [];
    const relatedItems = relationsByCode?.[UPSELL_RELATED] || [];

    if (!isLoading && !combinedItems.length && !relatedItems.length) {
        return null;
    }

    return (
        <>
            <RelationSlider
                isLoading={isLoading}
                items={combinedItems}
                title={upsellOptions.upsell_combined_title}
                link={upsellOptions.upsell_combined_link}
            />
            <RelationSlider
                isLoading={isLoading}
                items={relatedItems}
                title={upsellOptions.upsell_related_title}
                link={upsellOptions.upsell_related_link}
            />
        </>
    );
};

RelatedProductsSlider.propTypes = {
    relationsByCode: PropTypes.object,
    relationsFetched: PropTypes.bool,
};

RelatedProductsSlider.defaultProps = {
    relationsByCode: {},
    relationsFetched: false,
};

export default RelatedProductsSlider;
